<template>
	<div v-title title="发票" class="fp-page">
		<div class="key-val input-key-val al">
			<span class="key">发票抬头</span>
			<div class="val-tags">
				<span :class="fapiaoForm.payerType == '1' ? 'val-tag val-tag-s' : 'val-tag'"
					@click="fapiaoForm.payerType = '1'">个人</span>
				<span :class="fapiaoForm.payerType == '2' ? 'val-tag val-tag-s' : 'val-tag'"
					@click="fapiaoForm.payerType = '2'">公司</span>
			</div>
		</div>
		<section v-if="fapiaoForm.payerType == '1'">
			<div class="key-val input-key-val">
				<span class="key">
					抬头名称<span class="red-x">*</span>
				</span>
				<input class="val-input" v-model="fapiaoForm.payerName" type="text" placeholder="请填写您的姓名">
			</div>
			<div class="key-val input-key-val">
				<span class="key">手机号码<span class="red-x">*</span></span>
				<input class="val-input" v-model="fapiaoForm.receiverPhone" type="text" placeholder="请填写手机号码">
			</div>
			<div class="key-val input-key-val">
				<span class="key">邮箱地址<span class="red-x">*</span></span>
				<input class="val-input" v-model="fapiaoForm.receiverEmail" type="text" placeholder="请填写邮箱地址">
			</div>
		</section>
		<section v-else>
			<div class="key-val input-key-val">
				<span class="key">抬头名称<span class="red-x">*</span></span>
				<input class="val-input" v-model="fapiaoForm.payerName" type="text" placeholder="请填写企业名称">
			</div>
			<div class="key-val input-key-val">
				<span class="key">税号<span class="red-x">*</span></span>
				<input class="val-input" v-model="fapiaoForm.payerRegisterNo" type="text" placeholder="请填写纳税人识别号">
			</div>
			<div class="key-val input-key-val">
				<span class="key">邮箱地址<span class="red-x">*</span></span>
				<input class="val-input" v-model="fapiaoForm.payerEmail" type="text" placeholder="请填写邮箱地址">
			</div>
			<div class="key-val input-key-val">
				<span class="key">开户银行</span>
				<input class="val-input" v-model="fapiaoForm.payerBank" type="text" placeholder="选填">
			</div>
			<div class="key-val input-key-val">
				<span class="key">银行卡号</span>
				<input class="val-input" v-model="fapiaoForm.payerAccount" type="text" placeholder="选填">
			</div>
			<div class="key-val input-key-val">
				<span class="key">企业电话</span>
				<input class="val-input" v-model="fapiaoForm.payerPhone" type="text" placeholder="选填">
			</div>
			<div class="key-val input-key-val">
				<span class="key">企业地址</span>
				<input class="val-input" v-model="fapiaoForm.payerAddress" type="text" placeholder="选填">
			</div>
		</section>
		<div class="key-val input-key-val">
			<span class="key">设为默认抬头</span>
			<img class="icon-default" v-if="fapiaoForm.isDefault == 1" src="@/assets/images/product/icon_default.png"
				@click="fapiaoForm.isDefault = 0" />
			<span class="icon-default-none" v-else @click="fapiaoForm.isDefault = 1"></span>
		</div>

		<div class="btn-box" @click="confirmFapiao">
			<div class="btn">
				确认
			</div>
		</div>
		<!-- 
		<div class="sku_content_box normal_whitegb_box" style="margin-top: 0;padding: 5px 4vw">
			<div class="sku_content_title">
				发票抬头
			</div>

			<div class="sku_content_detail_left">
				<span @click="changeType(1)" :class="fapiaoForm.payerType == 1 ? 'fapiao_type_box_active' : 'fapiao_type_box'">
					个人
				</span>

				<span @click="changeType(2)" :class="fapiaoForm.payerType == 2 ? 'fapiao_type_box_active' : 'fapiao_type_box'">
					企业
				</span>
			</div>
		</div>

		<div class="fapiao_tip1 flex-row" style="padding: 5px 4vw">
		</div>


		<div class="sku_content_box normal_whitegb_box" style="margin-top: 0;padding: 5px 4vw">
			<div class="sku_content_title" style="line-height: 44px">
				抬头名称
			</div>

			<div class="sku_content_detail_left font15rem">
				<van-field v-model="fapiaoForm.payerName" :placeholder="fapiaoForm.payerType == 1 ? '请输入您的姓名' : '请输入企业名称'" />
			</div>
		</div>

		<div v-if="fapiaoForm.payerType == 1" class="sku_content_box normal_whitegb_box"
			style="margin-top: 0;padding: 5px 4vw">
			<div class="sku_content_title" style="line-height: 44px">
				手机号码
			</div>

			<div class="sku_content_detail_left font15rem">
				<van-field v-model="fapiaoForm.receiverPhone" placeholder="请输入手机号码" />
			</div>
		</div>

		<div v-if="fapiaoForm.payerType == 1" class="sku_content_box normal_whitegb_box"
			style="margin-top: 0;padding: 5px 4vw">
			<div class="sku_content_title" style="line-height: 44px">
				邮箱地址
			</div>

			<div class="sku_content_detail_left font15rem">
				<van-field v-model="fapiaoForm.receiverEmail" placeholder="请输入邮箱地址" />
			</div>
		</div>

		<div v-if="fapiaoForm.payerType == 2" class="sku_content_box normal_whitegb_box"
			style="margin-top: 0;padding: 5px 4vw">
			<div class="sku_content_title" style="line-height: 44px">
				税号
			</div>
			<div class="sku_content_detail_left font15rem">
				<van-field v-model="fapiaoForm.payerRegisterNo" placeholder="请输入纳税人识别号" />
			</div>
		</div>

		<div v-if="fapiaoForm.payerType == 2" class="sku_content_box normal_whitegb_box"
			style="margin-top: 0;padding: 5px 4vw">
			<div class="sku_content_title" style="line-height: 44px">
				邮箱地址
			</div>
			<div class="sku_content_detail_left font15rem">
				<van-field v-model="fapiaoForm.payerEmail" placeholder="请输入邮箱地址" />
			</div>
		</div>


		<div v-if="fapiaoForm.payerType == 2" class="sku_content_box normal_whitegb_box"
			style="margin-top: 0;padding: 5px 4vw">
			<div class="sku_content_title" style="line-height: 44px">
				开户银行
			</div>
			<div class="sku_content_detail_left font15rem">
				<van-field v-model="fapiaoForm.payerBank" placeholder="选填" />
			</div>
		</div>

		<div v-if="fapiaoForm.payerType == 2" class="sku_content_box normal_whitegb_box"
			style="margin-top: 0;padding: 5px 4vw">
			<div class="sku_content_title" style="line-height: 44px">
				银行卡号
			</div>
			<div class="sku_content_detail_left font15rem">
				<van-field v-model="fapiaoForm.payerAccount" placeholder="选填" />
			</div>
		</div>

		<div v-if="fapiaoForm.payerType == 2" class="sku_content_box normal_whitegb_box"
			style="margin-top: 0;padding: 5px 4vw">
			<div class="sku_content_title" style="line-height: 44px">
				企业电话
			</div>
			<div class="sku_content_detail_left font15rem">
				<van-field v-model="fapiaoForm.payerPhone" placeholder="选填" />
			</div>
		</div>

		<div v-if="fapiaoForm.payerType == 2" class="sku_content_box normal_whitegb_box"
			style="margin-top: 0;padding: 5px 4vw">
			<div class="sku_content_title" style="line-height: 44px">
				企业地址
			</div>
			<div class="sku_content_detail_left font15rem">
				<van-field v-model="fapiaoForm.payerAddress" placeholder="选填" />
			</div>
		</div>

		<van-cell center title="设为默认">
			<template #right-icon>
				<van-switch active-color="#ee0a24" :active-value="1" :inactive-value="0" v-model="fapiaoForm.isDefault"
					size="24" />
			</template>
</van-cell>

<div style="position: fixed;bottom: 3vh;width: 90vw;left: 5vw">
	<van-button color="#ee0a24" block @click="confirmFapiao">
		确认
	</van-button>
</div> -->
		<MyDialog :dialogForm="dialogForm" />
		<div ref="maidian" td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/orderApplyFapiao"></div>
	</div>
</template>

<script>
import MyDialog from '@/components/MyDialog.vue'
export default {
	name: "Order",
	components: {
		MyDialog,
	},
	data() {
		return {
			dialogForm: {
				show: false,
				title: '',
				contentText: '',
				contentTips: '',
				// btnCancelText: '取 消',
				btnConfirmText: '',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
				}
			},
			searchForm: {
				orderId: ''
			},
			fapiaoForm: {
				// 1个人 2企业
				payerType: 1,
				payerName: '',//个人
				receiverPhone: '',//个人
				receiverEmail: '',//个人
				payerRegisterNo: '',//税号
				payerEmail: '',//企业邮箱
				payerBank: '',//企业银行
				payerAccount: '',//企业银行卡号
				payerPhone: '',//企业电话
				payerAddress: '',//企业地址
				isDefault: 0
			}
		};
	},
	created() {


		if (this.$route.query.fapiaoid !== undefined) {
			this.getDetail()
		}

		let self = this
		this.$nextTick(() => {
			self.$refs['maidian'].click()
		})
	},
	methods: {
		submit() {

		},
		onClickLeft() {

			this.$router.push({
				path: '/orderFapiaoList',
				query: {
					orderId: this.$route.query.orderId,
					status: this.$route.query.status
				}
			})
		},
		getDetail() {
			this.$get('member/billAddress/' + this.$route.query.fapiaoid, {}).then((res) => {
				console.log(res)
				if (res.code === this.GLOBAL.SUCCESS) {
					this.fapiaoForm = res.data
				} else {
					this.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754A'
					})
				}
			})
		},
		apply() {
			this.$router.push({
				path: '/addressDetail',
				query: { fromPage: 'orderFapiao' }
			});
		},
		changeType(v) {
			this.fapiaoForm = {
				// 1个人 2企业
				payerType: v,
				payerName: '',//个人
				receiverPhone: '',//个人
				receiverEmail: '',//个人
				payerRegisterNo: '',//税号
				payerEmail: '',//企业邮箱
				payerBank: '',//企业银行
				payerAccount: '',//企业银行卡号
				payerPhone: '',//企业电话
				payerAddress: '',//企业地址
			}
		},
		confirmFapiao() {
			let self = this

			if (this.fapiaoForm.payerName.indexOf('交通银行') > -1) {
				self.$toast('该名称不可用，请重新输入');
				return
			}
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '确认提交信息？',
				contentTips: '',
				btnCancelText: '暂不提交',
				btnConfirmText: '确认',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
					let url = ''
					if (this.$route.query.fapiaoid !== undefined) {
						url = 'member/billAddress/update/' + this.$route.query.fapiaoid
						this.fapiaoForm.id = this.$route.query.fapiaoid
					} else {
						url = 'member/billAddress/add'
					}

					this.$post(url, this.fapiaoForm).then((res) => {
						console.log(res)
						if (res.code === this.GLOBAL.SUCCESS) {
							self.$toast(res.message);
							this.$router.push({
								path: '/orderFapiaoList',
								query: {
									orderId: this.$route.query.orderId,
									status: this.$route.query.status
								}
							})
						} else {
							this.$dialog.alert({
								theme: 'round-button',
								message: res.message,
								confirmButtonColor: '#00754A'
							})
						}
					})
				}
			}
		}
	},
}
</script>

<style scoped lang="less">
.fp-page {
	box-sizing: border-box;
	padding: 12px 14px;
	background-color: #fff;
	height: 100vh;

	.key-val {
		margin: 16px 0;
		padding: 0 2px;
		min-height: 16px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: space-between;
		align-items: flex-start;

		.key {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #666666;
			line-height: 16px;
		}

		.val {
			text-align: right;
			width: 240px;
			line-height: 18px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #333333;
		}



		.img {
			width: 149px;
		}
	}

	.key-val:first-child {
		margin-top: 0;
	}

	.input-key-val {
		align-items: center;
		height: 40px;
		position: relative;

		.key {
			width: 80px;

			.red-x {
				color: #FF4E4E;
				font-size: 13px;
			}
		}

		.val-input {
			box-sizing: border-box;
			padding: 12px;
			flex: 1;
			border: none;
			height: 40px;
			line-height: 40px;
			background: #F7F7F7;
			border-radius: 10px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #333333;

			.text-addr {
				height: 40px;
				line-height: 40px;
				width: 220px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #333;
			}

			.icon-addr-r {
				width: 14px;
				height: 14px;
			}

			.grey {
				color: #CCCCCC;
			}
		}

		.val-input::placeholder {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #CCCCCC;
		}

		.val-input-addr {
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: center;
		}

		.edit-tt {
			position: absolute;
			top: 14px;
			right: 12px;
			display: flex;
			align-content: center;
			justify-content: center;
			align-items: center;

			.edit-tt-text {
				height: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #00754A;
				line-height: 14px;
			}

			.edit-tt-icon {
				width: 12px;
				height: 12px;
			}

		}

		.val-tags {
			.val-tag {
				margin-right: 10px;
				height: 28px;
				line-height: 28px;
				box-sizing: border-box;
				padding: 12px;
				background: #F7F7F7;
				border-radius: 10px;
				font-weight: 400;
				font-size: 13px;
				color: #CCCCCC;
			}

			.val-tag-s {
				background: rgba(0, 117, 74, 0.06);
				color: #00754A;
			}
		}

		.icon-default {
			width: 16px;
			height: 16px;
		}

		.icon-default-none {
			box-sizing: border-box;
			width: 16px;
			height: 16px;
			background: #FFFFFF;
			border-radius: 4px;
			border: 1px solid #EEEEEE;
		}
	}

	.al {
		justify-content: flex-start
	}

	.btn-box {
		position: fixed;
		left: 0;
		bottom: 0;
		width: 375px;
		height: 49px;
		background: #FFFFFF;
		padding: 5px 0 0;

		.btn {
			margin: 0 auto;
			width: 355px;
			height: 40px;
			background: #00754A;
			border-radius: 10px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #FFFFFF;
			line-height: 40px;
			text-align: center;
		}
	}

}
</style>


// WEBPACK FOOTER //
// src/view/order/orderApplyFapiao.vue